<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 18">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M.875 9 5 0l4.125 9L5 18 .875 9ZM5 10.145 2.75 8.51 5 3.6l2.25 4.91L5 10.145Z" fill="currentColor"/>
</svg>
